import { Component, Input, Output, EventEmitter, ContentChild, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { IFieldSpecs } from '../interfaces/field-specs';
import { AutocompleteInputComponent } from './autocomplete-input.component';

@Component({
    selector: 'autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ["./autocomplete.component.scss"],
})
export class AutocompleteComponent<TValue> {
    @Input()
    public fieldConfig: IFieldSpecs;
    @Input()
    public forceFocus: boolean;
    @Input()
    public delayBlur: boolean = true;
    @Input()
    public forceBlur: boolean;
    @Input()
    public allowSelectOnBlur: boolean;
    @Input()
    public options: Observable<TValue>;
    @Input()
    public displayFn: (value: TValue) => string;
    @Input()
    public isExactMatchFn: (value: TValue, text: string) => string;
    @Input()
    public createFn: (text: string) => TValue;
    @Input()
    public isLoading: boolean;
    @Input()
    public autoActiveFirstOption: boolean = true;
    @Input()
    public autocompleteDisabled: boolean = false;
    @Input()
    public autocompleteTransparent: boolean = true;
    @Input()
    public removeEmptyOptions: boolean= false;
    @Input()
    public isInternalError: boolean= false;


    @Output()
    public readonly onChangeInput: EventEmitter<string> = new EventEmitter();
    @Output()
    public readonly onBlur: EventEmitter<FocusEvent> = new EventEmitter();
    @Output()
    public readonly onFocus: EventEmitter<FocusEvent> = new EventEmitter();
    @Output()
    public readonly onValueSelected: EventEmitter<TValue> = new EventEmitter();
    @Output()
    public readonly onOpenPanel: EventEmitter<void> = new EventEmitter();
    @Output()
    public readonly onClosePanel: EventEmitter<void> = new EventEmitter();
    @Output()
    public readonly onKeyUp: EventEmitter<KeyboardEvent> = new EventEmitter();
    @Output()
    public readonly onInputBlur: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();

    @ContentChild(TemplateRef)
    // tslint:disable-next-line:no-any
    public template: TemplateRef<any>;

    @ViewChild('input')
    public input: AutocompleteInputComponent<TValue>;

    public openPanel(): void {
        this.input.openPanel();
    }

    public closePanel(): void {
        this.input.closePanel();
    }

    public focus(): void {
        this.input.focus();
    }

    public blur(): void {
        this.input.blur();
    }

    public changeInputEvent(event: any): void {
        this.onChangeInput.emit(event);
    }

    public blurEvent(event: any): void {
        this.onBlur.emit(event);
    }

    public focusEvent(event: any): void {
        this.onFocus.emit(event);
    }

    public valueSelectedEvent(event: any): void {
        this.onValueSelected.emit(event);
    }

    public openPanelEvent(): void {
        this.onOpenPanel.emit();
    }

    public closePanelEvent(): void {
        this.onClosePanel.emit();
    }

    public keyUpEvent(event: any): void {
        this.onKeyUp.emit(event);
    }
}
